import { t, Trans } from '@lingui/macro';
import { ContentWrapper, LoadingScreen, NoddiBasicCard, NoddiDummyButton } from 'noddi-ui-web';

import { noddiAsync, URLKeys } from 'noddi-async';
import { customerRoutes } from 'noddi-util';
import { ApiErrorPageWithTrans } from '../../components/ApiErrorPageWithTrans';
import { InstructionRow } from '../../components/InstructionsRow';
import { ReferralCard } from './ReferralCard';
import { getHardCodedSalesItems } from './getHardCodedSalesItem';

export const BookingConfirmation = ({ slug }: { slug: string }) => {
  const {
    data: bookingDetails,
    isPending: isBookingDetailsPending,
    error: bookingDetailsError
  } = noddiAsync.useGet({
    type: URLKeys.getBookingInfo,
    input: { slug }
  });

  if (isBookingDetailsPending || isBookingDetailsPending) {
    return <LoadingScreen />;
  }
  if (bookingDetailsError || bookingDetailsError) {
    return <ApiErrorPageWithTrans error={bookingDetailsError} />;
  }

  // Get all sales item IDs from the order
  const bookingSalesItemIds =
    bookingDetails.order.orderLines.carOrderLines.flatMap((orderLine) =>
      orderLine.orderLines.map((orderLine) => orderLine.salesItemId)
    ) || [];

  // Filter the hardcoded items that match what's in the booking
  const matchingItems = getHardCodedSalesItems().filter((item) =>
    item.ids.some((id) => bookingSalesItemIds.includes(id))
  );

  return (
    <ContentWrapper hideBackButton title={t`Booking confirmed`}>
      <div className='flex flex-col gap-4'>
        <NoddiBasicCard
          className='flex flex-col gap-3'
          to={customerRoutes.myBookingDetails.getPath({ id: bookingDetails.id })}
        >
          <p className='font-bold text-xl text-primary'>
            <Trans>What happens next?</Trans>
          </p>
          <div className='flex flex-col gap-2'>
            <InstructionRow
              icon='Check'
              title={t`Order confirmation`}
              description={t`A confirmation message will be sent to you via SMS shortly`}
            />
            <InstructionRow
              icon='Phone'
              title={t`We will keep you updated about when we arrive`}
              description={t`We'll text you the day before with estimated arrival time and when you're next on the list`}
            />

            {/* Dynamically render instruction rows based on matching sales items */}
            {matchingItems.map((item, index) => (
              <InstructionRow key={index} icon={item.icon} title={item.name} description={item.description} />
            ))}

            <InstructionRow
              icon='MoneyCase'
              title={t`Payment`}
              description={t`Once the job is complete, you'll receive a payment link via SMS`}
            />
          </div>
          <div className='flex justify-end'>
            <NoddiDummyButton size='small' endIcon='ArrowRight'>
              <Trans>See booking</Trans>
            </NoddiDummyButton>
          </div>
        </NoddiBasicCard>
        <ReferralCard />
      </div>
    </ContentWrapper>
  );
};
